export const ROUTES = [
    {
      name: 'Century Development Industrial Park',
      path: '/centurydevelopmentindustrialpark',
      endpoint: '/Century%20Development%20Industrial%20Park/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'On Hold',
      sponsor: 'Century Development Assocs., LLC'
    },
    {
      name: 'CrossRoads East Business Park – Phase 2',
      path: '/crossroadseastbusinessparkphase2',
      endpoint: '/CrossRoads%20East%20Business%20Park%20%E2%80%93%20Phase%202/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'In Progress',
      sponsor: 'Mericle Commercial Real Estate Services'
    },
    {
      name: 'Lilly Lehigh Valley',
      path: '/lillylehighvalley',
      endpoint: '/Lilly%20Lehigh%20Valley/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'In Progress',
      sponsor: 'Eli Lilly and Company'
    },
    {
      name: 'Martinsburg Community Digester',
      path: '/martinsburgdigester',
      endpoint: '/Martinsburg%20Community%20Digester/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'On Hold',
      sponsor: 'GRUPPO'
    },
    {
      name: 'PennSTART',
      path: '/pennstart',
      endpoint: '/PennSTART/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'Complete',
      sponsor: 'RIDC'
    },
    {
      name: 'Project Tribeca',
      path: '/projecttribeca',
      endpoint: '/Project%20Tribeca/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'In Progress',
      sponsor: 'Johnson & Johnson'
    },
    {
      name: 'The Bellwether District',
      path: '/bellwether',
      endpoint: '/The%20Bellwether%20District/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'In Progress',
      sponsor: 'HRP Group'
    },
    {
      name: 'URBN Nuuly Bucks County',
      path: '/urbnnuulybuckscounty',
      endpoint: '/URBN%20Nuuly%20Bucks%20County/project.json?sv=2023-11-03&st=2024-07-19T04%3A00%3A00Z&se=9999-07-21T03%3A59%3A00Z&sr=c&sp=rl&sig=ylxhyjRo%2BdsuLvJqYVvEACgOMn8pFADm6oYRBHgRlxw%3D',
      status: 'In Progress',
      sponsor: 'Urban Outfitters, Inc.'
    }
  ]
